import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { selectMCBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { selectMCByLocation } from 'shared/slice/masterControlSelectByLocationSlice';
import { selectUnits } from 'shared/slice/unitsSlice';

import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  cardPanel,
  cardInput,
} from 'shared/styles/commonStyles';
import styled from 'styled-components';

import SchedulerContainer2 from './SchedulerContainer2';
import SelectLocations from './SelectLocations';
import ScheduleCalendar from 'features/masterControl/components/controls/heatingScheduler/ScheduleCalendar';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';
import { validateTemp, TEMP_ERROR_MESSAGES } from 'features/masterControl/components/shared/tempValidation';
import MobileControlLayout from 'features/masterControl/components/shared/MobileControlLayout';

import {
  SwitchSectionTop,
} from 'features/masterControl/components/shared/styles/switchCardStyles';

import {
  SwitchButtonWrapper,
  SwitchButtonHole,
  SwitchButtonTop,
  MessageBoxWrapper,
} from 'features/masterControl/components/shared/styles/controlButtons';

import { SectionSelect } from 'features/masterControl/components/shared/styles/mobileLayout';

const HeatingSchedule = ({
  scope,
  swtName,
  handleOnClick,
  handleCloseSelect,
  specificLocation,
  disabled,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });
  const type = scope === 'switch' ? 'locations' : 'switches';

  const switchStatus = useSelector(
    scope === 'switch' ? selectMCBySwitch : selectMCByLocation
  );
  const { selectedOne } = switchStatus.heatingSchedule;
  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;

  const [tempInput, setTempInput] = useState('');
  const [openScheduler, setOpenScheduler] = useState(false);
  const [scheduleData, setScheduleData] = useState({
    start: { date: null, time: null },
    end: { date: null, time: null },
    inputTemp: tempInput,
    isF: null,
  });
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);

  const handleClear = () => {};

  const handleClose = () => {
    setOpenScheduler(false);
  };

  const handleSetNewSchedule = (data) => {
    setScheduleData(data);
    setOpenScheduler(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isReady = selectedOne && scheduleData.start.date ? true : false;

    if (!isReady) {
      setOpenMessageBox(true);
      setMessages([
        'select locations and a schedule',
        'please select location and a start date and end date',
      ]);

      handleOnClick(
        'heatingSchedule',
        'selectB',
        scope,
        '_',
        '_',
        type,
        specificLocation
      );
    } else {
      if (tempInput) {
        const temp = Number(tempInput);
        const data = {
          start: scheduleData.start,
          end: scheduleData.end,
          inputTemp: temp,
          isF: isF,
        };

        if (validateTemp(temp, 'heatingSchedule', isF)) {
          handleOnClick('heatingSchedule', 'on', scope, 0, data);
          setScheduleData({
            start: { date: null, time: null },
            end: { date: null, time: null },
            inputTemp: tempInput,
            isF: null,
          });
          if (isMobile && scope !== 'switch') {
            handleCloseSelect();
          }
        } else {
          setOpenMessageBox(true);
          setMessages(TEMP_ERROR_MESSAGES.heatingSchedule);
          handleOnClick(
            'heatingSchedule',
            'tempA',
            scope,
            null,
            null,
            null,
            specificLocation
          );
        }
      } else {
        handleOnClick(
          'heatingSchedule',
          'tempA',
          scope,
          null,
          null,
          null,
          specificLocation
        );
        setOpenMessageBox(true);
        setMessages(TEMP_ERROR_MESSAGES.heatingSchedule);
      }
    }
    setTempInput('');
  };

  const schedulerCalendar = openScheduler && (
    <ScheduleCalendarWrapper isMobile={isMobile}>
      <ScheduleCalendar
        handleScheduler={handleSetNewSchedule}
        handleClose={handleClose}
        handleClear={handleClear}
        scheduleList={scheduleData}
        unit={isF}
      />
    </ScheduleCalendarWrapper>
  );


  if (isMobile) {
    return (
      <MobileControlLayout
        scope={scope}
        swtName={swtName}
        specificLocation={specificLocation}
        controlName='heatingSchedule'
        logoSrc='images/logo-schedule.svg'
        label={
          <>
            heating <br />schedule<br />program
          </>
        }
        labelSmall={
          <>
            heating <br />schedule
          </>
        }
        hasInput
        tempInput={tempInput}
        onTempChange={(e) => setTempInput(e.target.value)}
        placeholder={isF ? '0\u00B0F' : '0 \u00B0C'}
        onApply={handleSubmit}
        onSubmit={handleSubmit}
        subtitle='heating schedule program'
        messages={messages}
        openMessageBox={openMessageBox}
        onCloseMessageBox={() => setOpenMessageBox(false)}
        extraExpandedContent={
          <>
            <SchedulerContainer2
              isSmall={false}
              handleOpenScheduler={() => setOpenScheduler(!openScheduler)}
              start={scheduleData.start}
              end={scheduleData.end}
            />
            {schedulerCalendar}
          </>
        }
        extraLocationContent={
          <>
            <SectionSelect>
              <SchedulerContainer2
                handleOpenScheduler={() => setOpenScheduler(!openScheduler)}
                start={scheduleData.start}
                end={scheduleData.end}
                isSmall
              />
            </SectionSelect>
            {schedulerCalendar}
          </>
        }
      />
    );
  }


  return (
    <Wrapper>
      <SwitchSectionTop>
        <TitleWrapper>
          <Title>heating schedule program</Title>
        </TitleWrapper>

        <SelectLocations
          size={1}
          name='heatingSchedule'
          scope={scope}
          swtName={swtName}
          specificLocation={specificLocation}
        />
      </SwitchSectionTop>

      <SectionScheduler>
        <SchedulerTitle>start & end date</SchedulerTitle>
        <SchedulerContainer2
          handleOpenScheduler={() => setOpenScheduler(!openScheduler)}
          start={scheduleData.start}
          end={scheduleData.end}
        />
      </SectionScheduler>

      <SectionInputAndButton>
        <InputAndButtonWrapper onSubmit={handleSubmit}>
          <InputWrapper>
            <InputTemp
              type='text'
              onChange={(e) => setTempInput(e.target.value)}
              value={tempInput}
              placeholder='input temp.'
            />
          </InputWrapper>

          <SwitchButtonWrapper
            $w='80px'
            $h='40px'
            disabled={disabled}
          >
            <SwitchButtonHole disabled={disabled}>
              <SwitchButtonTop disabled={disabled}>
                apply
              </SwitchButtonTop>
            </SwitchButtonHole>
          </SwitchButtonWrapper>
        </InputAndButtonWrapper>
      </SectionInputAndButton>

      {schedulerCalendar}

      {openMessageBox && (
        <MessageBoxWrapper $top='180px' $left='auto'>
          <InputTempMessage
            onClose={() => setOpenMessageBox(false)}
            title='master control'
            subtitle='heating schedule program'
            messages={messages}
            isMobile={isMobile}
          />
        </MessageBoxWrapper>
      )}
    </Wrapper>
  );
};

export default HeatingSchedule;



const Wrapper = styled.div`
  ${cardPanel}
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16.8px;
  width: 100%;
  position: relative;
  overflow: visible;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 112px;
    height: 112px;
    background-image: url('images/logo-schedule.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.06;
    pointer-events: none;
    z-index: 0;
  }
`;

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  z-index: 1;
`;

const Title = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--switch-text-secondary);
  text-transform: capitalize;
`;

const SectionScheduler = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  margin-top: auto;
  position: relative;
  z-index: 1;
`;

const SchedulerTitle = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  color: var(--switch-text-secondary);
  text-transform: lowercase;
  text-align: center;
`;

const SectionInputAndButton = styled.section`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  z-index: 1;
`;

const InputAndButtonWrapper = styled.form`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  ${justifyContentSpaceBetween}
`;

const InputWrapper = styled.div`
  ${flexBoxCenter}
  flex: 1;
`;

const InputTemp = styled.input`
  width: 100%;
  height: 40px;
  ${cardInput}
  border-radius: 9999px;
  box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.8);
  padding: 8px 16px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--switch-text-secondary);
  text-align: center;

  &::placeholder {
    color: var(--switch-text-muted);
  }
`;

const ScheduleCalendarWrapper = styled.div`
  width: 100%;
  ${flexBoxCenter}
  position: absolute;
  top: 0;
  left: 0;
  z-index: 105;
`;
